import React, { PureComponent } from 'react';
import { node, string } from 'prop-types';
import { currency as currencyUtil } from 'utils';
import { withPlatform } from 'connectors';
import { Provider } from './CurrencyContext';

class CurrencyProvider extends PureComponent {
    static propTypes = {
        children: node,
        platform: string.isRequired,
    };

    static defaultProps = {
        children: null,
    };

    constructor(props) {
        super(props);

        this.state = {
            // eslint-disable-next-line react/no-unused-state
            currency: {
                value: currencyUtil.getCurrency(props.platform) || '',
            },
        };
    }

    render() {
        const { children } = this.props;
        return (
            <Provider
                value={{
                    state: this.state,
                }}
            >
                {children}
            </Provider>
        );
    }
}

export default withPlatform(CurrencyProvider);
